<auto-advice-home *ngIf="data.opType == 3" [data]="data" [demo]="data.demo" [index]="data.index"></auto-advice-home>
<auto-advice-superior *ngIf="data.opType == 4" [data]="data" [index]="data.index"></auto-advice-superior>
